import { Stack, Typography } from '@mui/material';
import { Provider } from '@repo/api-gw-sdk';

import { Tag } from '@/components/tag';

export const EonTagRemark = ({
  provider = Provider.Aws,
}: {
  provider?: Provider;
}) => {
  const tagValue =
    provider === Provider.Gcp ? 'eon-restore=true' : 'eon:restore=true';
  const term = provider === Provider.Gcp ? 'label' : 'tag';
  const text = `To help identify the restored resource, we’ll add this ${term}:`;

  return (
    <Stack alignItems='center' direction='row' gap='12px'>
      <Typography>{text}</Typography>
      <Tag variant='outlined' content={tagValue} />
    </Stack>
  );
};
